import { useFetch } from 'lib/hooks/useFetch';

interface ICsrfTokenResponse {
  csrfToken: string;
}

/**
 * Retrieve a CSRF token for the current user session.
 */
export const useCsrfToken = (): string => {
  const { data } = useFetch<ICsrfTokenResponse>('/auth/csrf', {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return data?.csrfToken;
};
